/* paex-size-advice.js — Size guide - PE: the ONE encoder of the hidden "_Size advice" line property and the
 * "_Size guide" cart attribute (Sasha 2026-10-05: "easy to read for a human for our customer service team, not
 * special codes"). Staff-facing English ONLY — the underscore keeps both out of the storefront cart and checkout;
 * they show on the admin order. Never a measurement value, a name or a profile id: only WHICH kinds were used.
 * Input = paexSizeGuide.track.outcomeParts() (TRACKING-FACTS §j). Loaded deferred BEFORE paex-size-guide.js by
 * snippets/paex-size-guide.liquid (PDP) and by snippets/paex-quick-add.liquid (quick add); every consumer looks it
 * up at call time, so a missing file only costs the stamp (the PDP keeps its server default, the cart backstop
 * in assets/paex-cart.js catches the rest). */
(function () {
  'use strict';
  if (window.paexSizeAdvice) return;
  var WORD = { h: 'height', w: 'weight', c: 'chest', t: 'waist', p: 'hips', a: 'age' };   // finder kinds letters (uppercase = proxied, same word)
  var LEVEL = { chart: 'Opened the size chart', finder: 'Used the size finder', profile: 'Has a saved size profile' };
  function size(v) {
    var s = v == null ? '' : String(v).replace(/\s+/g, ' ').trim();
    return /^default title$/i.test(s) ? '' : s.slice(0, 32);
  }
  function kinds(k) {
    var out = [];
    String(k || '').toLowerCase().split('').forEach(function (c) { var w = WORD[c]; if (w && out.indexOf(w) < 0) out.push(w); });
    return out.length === 1 ? out[0] + ' only' : out.join(', ');
  }
  // p: { added, tier, kinds, rec, src, sel, why, recLabel } — rec = the size the engine named (green / amber), '' when none;
  // why = the engine's reason for a NEUTRAL tier (base outcomeParts): need = a measurement this chart needs is missing from the
  // profile, unoffered = a chart row matched (recLabel) but this product does not sell that size, nomatch = no row matched,
  // off = no finder evaluation (finder off / nothing to ask) → worded like a plain chart view
  function neutral(p) {
    if (p.why === 'need') return 'Size finder used, but measurements this chart needs were missing';
    if (p.why === 'unoffered') { var l = size(p.recLabel); return l ? 'Size finder matched ' + l + ', which this product does not offer' : 'Size finder matched a size this product does not offer'; }
    return p.why === 'off' ? null : 'Size finder used, no size matched the measurements given';
  }
  function sentence(p) {
    if (!p) return null;
    var added = size(p.added), rec = size(p.rec), k = kinds(p.kinds), out = [], n;
    if (rec && (p.tier === 'green' || p.tier === 'amber')) {
      out.push((p.tier === 'green' ? 'We recommended ' + rec + ' (confident match' : 'We suggested ' + rec + ' (approximate') + (k ? ': ' + k : '') + ')');
      if (added) out.push(added.toLowerCase() !== rec.toLowerCase() ? 'Customer chose ' + added + ' instead' : (p.sel === 'pre' ? 'Customer kept our pre-selected ' + added : 'Customer chose ' + added));
    } else {
      n = p.tier === 'neutral' ? neutral(p) : null;
      out.push(n || (p.kind === 'chart' ? 'Customer opened the size chart (no recommendation)' : 'Size guide not used'));
      if (added) out.push('Customer chose ' + added);
    }
    return (out.join('. ') + (p.src === 'qa' ? ' (added from quick add)' : '') + '.').slice(0, 200);
  }
  function level(l) { return LEVEL[l] || null; }
  window.paexSizeAdvice = { KEY: '_Size advice', ATTR: '_Size guide', sentence: sentence, level: level, kinds: kinds };
})();
